<div class="statistic-container" [ngClass]="alignStatisticContainer">
  <div class="statistic-value">{{ formattedValue }}</div>
  <div *ngIf="delta !== null" class="statistic-delta-container" [ngClass]="deltaClass">
    <mat-icon *ngIf="delta > 0" class="statistic-delta-symbol">arrow_drop_up</mat-icon>
    <mat-icon *ngIf="delta < 0" class="statistic-delta-symbol">arrow_drop_down</mat-icon>
    <div class="statistic-delta-text">{{ formattedDelta }}</div>
  </div>
</div>
